import { observer } from 'mobx-react'
import { useContext } from 'react'
import { StoreContext } from '@store/Root.store'
import { Header, LoadingSpinner } from '@/components/Generic'
export const Redirect = observer(() => {
  const store = useContext(StoreContext)
  const { saltedgePage: trans } = store.TranslationsState.translations

  return (
    <>
      <Header>{trans.redirecting}</Header>
      <>
        <LoadingSpinner />

        <div className="layout__centered-content m-20-0-0-0">{`${trans.pleaseWait}`}</div>
      </>
    </>
  )
})
